import { render, staticRenderFns } from "./dialog-resend.vue?vue&type=template&id=3f0042ae&"
import script from "./dialog-resend.vue?vue&type=script&lang=js&"
export * from "./dialog-resend.vue?vue&type=script&lang=js&"
import style0 from "./dialog-resend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports